export default {
    state: {
        data: {}
    },
    mutations: {
        setCacheData (state, payload) {
            state.data = payload
        }
    },
    actions: {}
}
